import React from 'react'
import { formatDuration } from 'theme/web-app'
import LabeledField from 'components/LabeledField'
import { H2, HEADING_TYPES } from 'components/Heading'
import {
  SUBTYPE_CONTENT_YOGA,
  SUBTYPE_CONTENT_FITNESS,
  SUBTYPE_CONTENT_MEDITATION,
} from 'services/content-type'

/**
 * The share page content meta data section
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Map} props.content - The video content
 * @returns {JSX.Element} Meta data section
 */

function SharePageV3Meta (props) {
  const { content, staticText } = props
  const title = content.get('title')
  const seriesTitle = content.get('seriesTitle')
  const teaser = content.get('teaser')
  const yogaLevel = content.get('yogaLevel')
  const yogaStyle = content.get('yogaStyle')
  const fitnessLevel = content.get('fitnessLevel')
  const fitnessStyle = content.get('fitnessStyle')
  const episode = content.get('episode')
  const season = content.get('season')
  const duration = content.get('duration')
  const host = content.get('host')
  const guest = content.get('guest')
  const audioLangs = content.get('audioLangs')
  const subtitleLangs = content.get('subtitleLangs')
  const contentSubtype = content.get('contentSubtype')

  const isYogaFitnessMeditation = [
    SUBTYPE_CONTENT_YOGA,
    SUBTYPE_CONTENT_FITNESS,
    SUBTYPE_CONTENT_MEDITATION,
  ].includes(contentSubtype)

  const hostLabel = isYogaFitnessMeditation ? staticText.get('teacher') : staticText.get('host')

  const metaDataString = [
    season ? `S${season}:Ep${episode}` : null,
    duration ? formatDuration(duration) : null,
    host ? `${hostLabel}: ${host}` : null,
  ].filter((part) => !!part).join(', ')

  return (
    <div className="share-page-v3__meta">
      <div className="share-page-v3__meta-content">
        <H2 as={HEADING_TYPES.H5}>{title}</H2>
        <p className="share-page-v3__meta-data">{metaDataString}</p>

        {seriesTitle ? <LabeledField value={seriesTitle} label={staticText.get('series')} /> : null}

        {isYogaFitnessMeditation ? (
          <p className="share-page-v3__meta-yoga">
            {yogaStyle ? `${yogaLevel}, ${yogaStyle}` : null}
            {fitnessStyle ? `${fitnessLevel}, ${fitnessStyle}` : null}
          </p>
        ) : null}

        <p className="share-page-v3__meta-teaser">{teaser}</p>

        {host ? <LabeledField value={host} label={hostLabel} /> : null}
        {guest ? <LabeledField value={guest} label={staticText.get('featuring')} /> : null}
        {audioLangs ? <LabeledField value={audioLangs} label={staticText.get('audio')} /> : null}
        {subtitleLangs ? <LabeledField value={subtitleLangs} label={staticText.get('subtitles')} /> : null}
      </div>
    </div>
  )
}

export default SharePageV3Meta
